/**
 * Справочники очереди модерации компаний (DEV-795): статусы, табы, пороги уверенности,
 * привязка статус → вариант бейджа. Подписи берём из i18n (companyVerifications.status.*),
 * здесь — только значения и цвета.
 */
import type { BadgeVariant } from '@/design-system/components/AppBadge.vue'
import type { CompanyVerificationStatus, VerificationTab } from '../types/companyVerification.types'

/** Все статусы верификации (для фильтра «Статус»). Порядок = жизненный цикл. */
export const VERIFICATION_STATUSES: CompanyVerificationStatus[] = [
  'pending_ai',
  'ai_candidates',
  'ai_no_result',
  'agent_selected',
  'manager_review',
  'confirmed',
  'expired',
  'cancelled',
]

/** Статус верификации → цвет AppBadge. ai_candidates и manager_review — обе ждут менеджера. */
export const verificationStatusVariant: Record<string, BadgeVariant> = {
  pending_ai: 'neutral',
  ai_candidates: 'primary',
  ai_no_result: 'warning',
  agent_selected: 'info',
  manager_review: 'primary',
  confirmed: 'success',
  expired: 'error',
  cancelled: 'neutral',
}

/** Сентинел вкладки «Требуют действия»: бэкенд разворачивает в ai_candidates + manager_review. */
export const STATUS_ACTION_NEEDED = 'action_needed'

/** Сентинел вкладки «Просроченные»: открытые заявки с истёкшим дедлайном SLA (DEV-1165). */
export const STATUS_OVERDUE = 'overdue'

/** Табы очереди в порядке отображения. Просрочка — сразу за очередью, она горит. */
export const VERIFICATION_TABS: VerificationTab[] = [
  'action_needed',
  'overdue',
  'no_result',
  'mine',
  'all',
]

/**
 * Таб → серверный фильтр verificationStatus. «Требуют действия»/«Мои» шлют сентинел
 * action_needed (ai_candidates + manager_review); «Мои» дополнительно фильтруется по
 * responsibleId в сторе. «Просроченные» — сентинел overdue. «Все» — без фильтра статуса.
 */
export const TAB_STATUS: Record<VerificationTab, string | undefined> = {
  action_needed: STATUS_ACTION_NEEDED,
  overdue: STATUS_OVERDUE,
  no_result: 'ai_no_result',
  mine: STATUS_ACTION_NEEDED,
  all: undefined,
}

/** Пороги фильтра «Уверенность» (в процентах). 0 = любая. */
export const CONFIDENCE_THRESHOLDS = [0, 50, 70, 90] as const
